export default (that) => [
  {
    type: 'seq',
    title: '#',
    width: 50,
    fixed: 'left',
    align: 'center',
    slots: { default: 'seqno' },
  },
  {
    field: 'checkbox',
    width: 40,
    fixed: 'left',
    align: 'center',
    type: 'checkbox',
  },
  {
    field: 'opt',
    title: that.$l('INDEX.table_label_operation') || '操作',
    width: 90,
    fixed: 'right',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'opt' },
  },
  {
    field: 'remainCtnQty',
    title: that.$l('table_label_remainCtnQty') || '可分配箱数',
    minWidth: 100,
    fixed: 'left',
    align: 'center',
    showHeaderOverflow: true,
    slots: { default: 'remainCtnQty' },
  },
  {
    field: 'planNo',
    title: that.$l('form_label_planNos') || '补货计划编号',
    minWidth: 150,
    align: 'center',
    group: true,
    showHeaderOverflow: true,
    slots: { header: 'planNoHeader' },
  },
  {
    field: 'fbaDc',
    title: that.$l('table_label_fbaDc') || 'FBA DC',
    minWidth: 150,
    align: 'center',
    group: true,
    showHeaderOverflow: true,
    slots: { header: 'fbaDcHeader' },
  },
  {
    field: 'fbaId',
    title: that.$l('table_label_fbaId') || 'FBA ID',
    minWidth: 150,
    align: 'center',
    group: true,
    showHeaderOverflow: true,
    slots: { header: 'fbaIdHeader' },
  },
  {
    field: 'amzSkuNo',
    title: that.$l('table_label_sku') || 'SKU',
    minWidth: 140,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'amzSkuNoHeader' },
  },
  {
    field: 'amzStoreSkuNo',
    title: that.$l('table_label_storeSku') || '店铺 SKU',
    minWidth: 140,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'amzStoreSkuNoHeader' },
  },
  {
    field: 'totalVolume',
    title: that.$l('table_label_totalVolume') || '总体积(m³)',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'shippingFactoryName',
    title: that.$l('table_label_shippingFactoryName') || '送货工厂',
    minWidth: 220,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'shippingFactoryNameHeader' },
  },
  {
    field: 'goodsName',
    title: that.$l('table_label_goodsName') || '产品名称',
    minWidth: 220,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'goodsNameHeader' },
  },
  {
    field: 'goodsColor',
    title: that.$l('table_label_goodsColor') || '颜色',
    minWidth: 120,
    group: true,
    align: 'center',
    showHeaderOverflow: true,
    slots: { header: 'goodsColorHeader' },
  },
  {
    field: 'qty',
    title: that.$l('table_label_goodsQty') || '数量',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
  {
    field: 'ctnQty',
    title: that.$l('table_label_ctnQty') || '箱数',
    width: 120,
    align: 'center',
    showHeaderOverflow: true,
  },
]
